module.exports = __webpack_public_path__ + "static/media/intro-photowall-20.4260ec2d.jpg";